"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BinanceConfig = void 0;
const Tokens_1 = require("./Tokens");
const Types_1 = require("../../Types");
const MetamaskConnector_1 = require("../../Connectors/Wallets/MetamaskConnector");
const MathWalletConnector_1 = require("../../Connectors/Wallets/MathWalletConnector");
const Utils_1 = require("../Utils");
const BinanceChainWalletConnector_1 = require("./Wallets/BinanceChainWalletConnector");
const TrustWalletConnector_1 = require("../../Connectors/Wallets/TrustWalletConnector");
const MetamaskCompatibleConnector_1 = require("../../Connectors/Wallets/MetamaskCompatibleConnector");
const Factory_1 = require("../../Connectors/Factory");
const OntoWallet_1 = require("../../Connectors/Wallets/OntoWallet");
const WalletConnectConnector_1 = require("../../Connectors/Wallets/WalletConnectConnector");
const CoinbaseConnector_1 = require("../../Connectors/Wallets/CoinbaseConnector");
const TokenPocketConnector_1 = require("../../Connectors/Wallets/TokenPocketConnector");
exports.BinanceConfig = Utils_1.blockchainConfigFactory({
    blockchain: Types_1.Blockchains.Binance,
    chainId: Types_1.EthChainIds.Bsc,
    publicRpc: "https://bsc-dataseed.binance.org/",
    nativeToken: Tokens_1.BNBNativeToken,
    wrappedToken: Tokens_1.BNBWrappedToken,
    upToken: Tokens_1.BNBUpToken,
    unfiToken: Tokens_1.BNBUnfiToken,
    logoURI: "https://proxy.unifiprotocol.com/ipfs/QmU2EACvQ1YT7LTzHQdQEVMwDYVeeX3AHBHT9q5HQ4e5oK",
    multicall: {
        supported: true,
    },
    connectorFactory: Factory_1.web3ConnectorFactory,
    explorer: {
        baseUrl: "https://bscscan.com",
        address: function (address) {
            return `${this.baseUrl}/address/${address}`;
        },
        token: function (address) {
            return `${this.baseUrl}/token/${address}`;
        },
        tx: function (address) {
            return `${this.baseUrl}/tx/${address}`;
        },
    },
}, [
    MetamaskConnector_1.MetamaskConnector,
    BinanceChainWalletConnector_1.BinanceChainWalletConnector,
    TrustWalletConnector_1.TrustWalletConnector,
    MathWalletConnector_1.MathWalletConnector,
    TokenPocketConnector_1.TokenPocketConnector,
    MetamaskCompatibleConnector_1.MetamaskCompatibleConnector,
    OntoWallet_1.OntoWalletConnector,
    CoinbaseConnector_1.CoinbaseWalletConnector,
    WalletConnectConnector_1.WalletConnectConnector,
], [
    Factory_1.createWeb3OfflineConnectorHelper(Types_1.OfflineConnectors.BscDataseed, "https://bsc-dataseed.binance.org/"),
]);
